import { render, staticRenderFns } from "./ProfileDropDown.vue?vue&type=template&id=4317a726"
import script from "./ProfileDropDown.vue?vue&type=script&lang=js"
export * from "./ProfileDropDown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/latinad/panel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4317a726')) {
      api.createRecord('4317a726', component.options)
    } else {
      api.reload('4317a726', component.options)
    }
    module.hot.accept("./ProfileDropDown.vue?vue&type=template&id=4317a726", function () {
      api.rerender('4317a726', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layouts/components/navbar/components/ProfileDropDown.vue"
export default component.exports